import { useState } from 'react';
import { api } from '../api.js';
import { t } from '../i18n.js';
import Wachtwoordveld from '../components/Wachtwoordveld.jsx';

/**
 * Het wachtwoord van de noodingang wijzigen. Bij de eerste aanmelding verplicht: het wachtwoord
 * dat het script op de server toonde, heeft iemand gezien.
 */
export default function Wachtwoord({ verplicht = false, onKlaar }) {
  const [huidig, zetHuidig] = useState('');
  const [nieuw, zetNieuw] = useState('');
  const [fout, zetFout] = useState(null);
  const [klaar, zetKlaar] = useState(false);

  async function verstuur(e) {
    e.preventDefault();
    zetFout(null);
    try {
      await api.wijzigWachtwoord(huidig, nieuw);
      zetKlaar(true);
      onKlaar?.();
    } catch (err) {
      zetFout(t(err.details?.next ?? err.message));
    }
  }

  const formulier = (
    <form onSubmit={verstuur} className={verplicht ? undefined : 'card'} style={verplicht ? undefined : { maxWidth: 420, display: 'grid', gap: 12 }}>
      {verplicht && <><h1>ADTS ZERO</h1><p className="sub">{t('Je moet je wachtwoord nog wijzigen.')}</p></>}
      {fout && <div className="melder rood">{fout}</div>}
      {klaar && !verplicht && <div className="melder blauw">{t('Wachtwoord gewijzigd.')}</div>}
      <label className="field">{t('Huidig wachtwoord')}<Wachtwoordveld waarde={huidig} zet={zetHuidig} /></label>
      <label className="field">{t('Nieuw wachtwoord')}<Wachtwoordveld waarde={nieuw} zet={zetNieuw} autoComplete="new-password" />
        <span className="muted" style={{ fontSize: 12 }}>{t('Minimaal 12 tekens')}</span></label>
      <div><button className={verplicht ? undefined : 'btn primary'} disabled={!huidig || nieuw.length < 12}>{t('Wachtwoord wijzigen')}</button></div>
    </form>
  );

  if (verplicht) return <div className="aanmeld">{formulier}</div>;
  return (
    <>
      <div className="page-head"><div>
        <h1>{t('Wachtwoord wijzigen')}</h1>
        <p className="sub">{t('De noodingang, niet je ADTS-account')}</p>
      </div></div>
      {formulier}
    </>
  );
}
